export const USA_LOCATIONS = {
    // Major Cities
    newYorkCity: {
        country: 'USA',
        region: 'New York City',
        state: 'New York'
    },
    losAngeles: {
        country: 'USA',
        region: 'Los Angeles',
        state: 'California'
    },
    chicago: {
        country: 'USA',
        region: 'Chicago',
        state: 'Illinois'
    },
    houston: {
        country: 'USA',
        region: 'Houston',
        state: 'Texas'
    },
    phoenix: {
        country: 'USA',
        region: 'Phoenix',
        state: 'Arizona'
    },
    sanFrancisco: {
        country: 'USA',
        region: 'San Francisco',
        state: 'California'
    },
    miami: {
        country: 'USA',
        region: 'Miami',
        state: 'Florida'
    },
    seattle: {
        country: 'USA',
        region: 'Seattle',
        state: 'Washington'
    },

    // States
    alabama: {
        country: 'USA',
        region: 'Alabama',
    },
    alaska: {
        country: 'USA',
        region: 'Alaska',
    },
    arizona: {
        country: 'USA',
        region: 'Arizona',
    },
    arkansas: {
        country: 'USA',
        region: 'Arkansas',
    },
    california: {
        country: 'USA',
        region: 'California',
    },
    colorado: {
        country: 'USA',
        region: 'Colorado',
    },
    connecticut: {
        country: 'USA',
        region: 'Connecticut',
    },
    delaware: {
        country: 'USA',
        region: 'Delaware',
    },
    florida: {
        country: 'USA',
        region: 'Florida',
    },
    georgia: {
        country: 'USA',
        region: 'Georgia',
    },
    hawaii: {
        country: 'USA',
        region: 'Hawaii',
    },
    idaho: {
        country: 'USA',
        region: 'Idaho',
    },
    illinois: {
        country: 'USA',
        region: 'Illinois',
    },
    indiana: {
        country: 'USA',
        region: 'Indiana',
    },
    iowa: {
        country: 'USA',
        region: 'Iowa',
    },
    kansas: {
        country: 'USA',
        region: 'Kansas',
    },
    kentucky: {
        country: 'USA',
        region: 'Kentucky',
    },
    louisiana: {
        country: 'USA',
        region: 'Louisiana',
    },
    maine: {
        country: 'USA',
        region: 'Maine',
    },
    maryland: {
        country: 'USA',
        region: 'Maryland',
    },
    massachusetts: {
        country: 'USA',
        region: 'Massachusetts',
    },
    michigan: {
        country: 'USA',
        region: 'Michigan',
    },
    minnesota: {
        country: 'USA',
        region: 'Minnesota',
    },
    mississippi: {
        country: 'USA',
        region: 'Mississippi',
    },
    missouri: {
        country: 'USA',
        region: 'Missouri',
    },
    montana: {
        country: 'USA',
        region: 'Montana',
    },
    nebraska: {
        country: 'USA',
        region: 'Nebraska',
    },
    nevada: {
        country: 'USA',
        region: 'Nevada',
    },
    newHampshire: {
        country: 'USA',
        region: 'New Hampshire',
    },
    newJersey: {
        country: 'USA',
        region: 'New Jersey',
    },
    newMexico: {
        country: 'USA',
        region: 'New Mexico',
    },
    newYork: {
        country: 'USA',
        region: 'New York',
    },
    northCarolina: {
        country: 'USA',
        region: 'North Carolina',
    },
    northDakota: {
        country: 'USA',
        region: 'North Dakota',
    },
    ohio: {
        country: 'USA',
        region: 'Ohio',
    },
    oklahoma: {
        country: 'USA',
        region: 'Oklahoma',
    },
    oregon: {
        country: 'USA',
        region: 'Oregon',
    },
    pennsylvania: {
        country: 'USA',
        region: 'Pennsylvania',
    },
    rhodeIsland: {
        country: 'USA',
        region: 'Rhode Island',
    },
    southCarolina: {
        country: 'USA',
        region: 'South Carolina',
    },
    southDakota: {
        country: 'USA',
        region: 'South Dakota',
    },
    tennessee: {
        country: 'USA',
        region: 'Tennessee',
    },
    texas: {
        country: 'USA',
        region: 'Texas',
    },
    utah: {
        country: 'USA',
        region: 'Utah',
    },
    vermont: {
        country: 'USA',
        region: 'Vermont',
    },
    virginia: {
        country: 'USA',
        region: 'Virginia',
    },
    washington: {
        country: 'USA',
        region: 'Washington',
    },
    westVirginia: {
        country: 'USA',
        region: 'West Virginia',
    },
    wisconsin: {
        country: 'USA',
        region: 'Wisconsin',
    },
    wyoming: {
        country: 'USA',
        region: 'Wyoming',
    },
} as const;

export type USARegion = keyof typeof USA_LOCATIONS; 